import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "timer-part timer-days"
}
const _hoisted_2 = { class: "timer__number" }
const _hoisted_3 = { class: "timer__labels" }
const _hoisted_4 = {
  key: 1,
  class: "timer-part timer-hours"
}
const _hoisted_5 = { class: "timer__number" }
const _hoisted_6 = { class: "timer__labels" }
const _hoisted_7 = {
  key: 2,
  class: "timer__separate"
}
const _hoisted_8 = {
  key: 3,
  class: "timer-part timer-min"
}
const _hoisted_9 = { class: "timer__number" }
const _hoisted_10 = { class: "timer__labels" }
const _hoisted_11 = {
  key: 4,
  class: "timer__separate"
}
const _hoisted_12 = {
  key: 5,
  class: "timer-part timer-sec"
}
const _hoisted_13 = { class: "timer__number" }
const _hoisted_14 = { class: "timer__labels" }

import { ref, computed, onMounted } from "vue";
import Timer from "easytimer.js";
import { trans } from '@/utils/trans';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimerLive',
  props: {
  dataDays: {
    type: Number,
    default: 0,
  },
  dataHours: {
    type: Number,
    default: 0,
  },
  dataMinutes: {
    type: Number,
    default: 0,
  },
  dataSeconds: {
    type: Number,
    default: 0,
  },
  dataCountdown: {
    type: Boolean,
    default: false,
  }
},
  setup(__props) {

const props = __props;

const timer = new Timer();

const days = ref(props.dataDays);
const hours = ref<string>("");
const minutes = ref<string>("");
const seconds = ref<string>("");

const lessThanDay = computed(() => days.value <= 0);

const updateTimer = () => {
  const values = timer.getTimeValues();
  days.value = values.days;
  hours.value = values.hours.toString().padStart(2, '0');
  minutes.value = values.minutes.toString().padStart(2, '0');
  seconds.value = values.seconds.toString().padStart(2, '0');
};

onMounted(() => {
  timer.start({
    countdown: props.dataCountdown,
    startValues: {
      days: props.dataDays,
      hours: props.dataHours,
      minutes: props.dataMinutes,
      seconds: props.dataSeconds
    }
  });

  updateTimer();

  timer.addEventListener('secondsUpdated', () => updateTimer());
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["timer-live", { 'one-day-left': lessThanDay.value }])
  }, [
    (!lessThanDay.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(days.value), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(trans)("live.common.timer_full.days")), 1)
        ]))
      : _createCommentVNode("", true),
    (hours.value > 0 || !lessThanDay.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(hours.value), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(trans)("live.common.timer_full.hours")), 1)
        ]))
      : _createCommentVNode("", true),
    (hours.value > 0 || !lessThanDay.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, ":"))
      : _createCommentVNode("", true),
    (minutes.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(minutes.value), 1),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(trans)("live.common.timer_full.minutes")), 1)
        ]))
      : _createCommentVNode("", true),
    (hours.value < 1 && lessThanDay.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, ":"))
      : _createCommentVNode("", true),
    (hours.value < 1 && lessThanDay.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(seconds.value), 1),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(trans)("live.common.timer_full.seconds")), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})